import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import apiHelper from '../../utils/apiHelpers';
import Input from '../common/Input';
import Button from '../common/Button';
import Alert from '../common/Alert';

const RecoverPassword = () => {
  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState(null);

  const navigate = useNavigate();

  const handleChange = event => {
    const { value } = event.target;
    setEmail(value);
  };

  const handleSubmit = async () => {
    try {
      await apiHelper.resetPassword({ email });
      navigate('/login');
    } catch (error) {
      let errorMessage;
      if (error.response) {
        const statusCode = error.response.status;
        errorMessage =
          statusCode === 401 ? 'Email no encontrado' : error.message;
      } else {
        errorMessage = 'Error de conexión con el servidor';
      }
      setErrorMessage(errorMessage);
    }
  };

  return (
    <div className="flex flex-col w-full h-full items-center justify-center">
      <div className="flex flex-col items-center gap-y-4 min-w-[300px]">
        <h2 className="text-2xl font-semibold text-center">
          ¿Olvidaste tu contraseña?
        </h2>
        <p className="text-center text-lightColor">
          Ingresa tu dirección de email para recuperarla.
        </p>
        <Input
          type="email"
          name="email"
          placeholder="Dirección de Email"
          value={email}
          onChange={handleChange}
          required={true}
          autoFocus
        />
        <Alert>{errorMessage}</Alert>
        <Button className="w-full" onClick={handleSubmit}>
          Recuperar contraseña
        </Button>
        <Link
          to="/login"
          className="text-accentDark hover:text-accentLight hover:underline block text-center">
          Volver al Login
        </Link>
      </div>
    </div>
  );
};

export default RecoverPassword;
